import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@cms/ui/components/button";
import { ErrorAlert } from "@cms/ui/components/error-alert";
import { useApiQuery } from "@cms/portal-lib/hooks";
import { PageHeader } from "@cms/ui/components/page-header";
import { FormsHeader } from "../components/forms-header";
import { FormsListCard } from "../components/forms-list-card";
import { fetchForms } from "../lib/forms";
import type { ClientOutletContext } from "../lib/outlet-context";

/** The Forms section's Forms tab: build and manage form definitions. */
export function FormsBuildPage() {
  const { api, refreshStatus } = useOutletContext<ClientOutletContext>();

  const [createOpen, setCreateOpen] = useState(false);
  const forms = useApiQuery(() => (api ? fetchForms(api) : null), [api]);

  const handleFormDeleted = () => {
    refreshStatus();
    forms.reload();
  };

  return (
    <div>
      <FormsHeader />
      <PageHeader
        title="Forms"
        description="Build custom forms, then add them to any page with the Form block in the page editor."
        actions={
          <Button onClick={() => setCreateOpen(true)} size="sm">
            <Plus className="h-4 w-4" />
            Create form
          </Button>
        }
      />

      <ErrorAlert error={forms.error} />

      {api && (
        <FormsListCard
          api={api}
          forms={forms.data?.forms ?? null}
          createOpen={createOpen}
          onCreateOpenChange={setCreateOpen}
          onCreated={() => refreshStatus()}
          onDeleted={handleFormDeleted}
        />
      )}
    </div>
  );
}
